import comp from "./DraggableCell";
export default comp;
